export const BaseUrl = process.env.REACT_APP_GMG_CONSOLE_API_BASE_URL;
export const GingerMediaBaseUrl = process.env.REACT_APP_GINGER_MEDIA_API_BASE_URL;
export const AuthApiBaseUrl = process.env.REACT_APP_AUTH_API_BASE_URL;
export const clientId = process.env.REACT_APP_CLIENT_ID;
export const GingerMediaApiStorageBaseUrl = process.env.REACT_APP_STORAGE_API_BASE_URL;
export const SpotrueApiStorageBaseUrl = process.env.REACT_APP_SPOTRUE_API_BASE_URL

